<!-- @description企业微信侧边栏发送公开课卡片链接 -->
<template>
  <div class="sendCardLink">
    <div class="search-bar">
      <a-input-search
        v-model="keyword"
        placeholder="输入直播间名称/直播号/讲师名称"
        @search="onSearch" />
      <a-radio-group
        class="custom-radio-group"
        v-model="mode"
        @change="onChange"
        button-style="solid">
        <a-radio-button value=""> 全部 </a-radio-button>
        <a-radio-button value="2"> 直播 </a-radio-button>
        <a-radio-button value="3"> 回放 </a-radio-button>
      </a-radio-group>
    </div>
    <a-spin :spinning="loading">
      <div class="cardList">
        <template v-if="liveList.length > 0">
          <div class="cardItem" v-for="(item, index) in liveList" :key="index">
            <div class="left">
              <div class="title">
                <div class="t-left">{{ item.liveTitle }}</div>
                <div>
                  <span class="t-right">{{ getMode(item.mode) }}</span>
                </div>
              </div>
              <div class="no">
                <span class="teacher">讲师：{{ item.anchor }}</span>
                <span>频道号：{{ item.channelId }}</span>
              </div>
              <div class="no" v-if="item.startTime">
                <span>开课时间：{{ item.startTime || "-" }}</span>
                <span>{{ getLiveMode(item.liveMode) }}</span>
              </div>
            </div>
            <div class="right" @click="onSend(item)">发送</div>
          </div>
        </template>
        <template v-else>
          <div style="margin-top: 35%">
            <a-empty description="请联系管理员获取直播间权限" />
          </div>
        </template>
      </div>
    </a-spin>
  </div>
</template>
<script>
import * as ww from "@wecom/jssdk";
import { envjudge } from "@/utils/index";
import { getCurExternalContact } from "@/utils/wxCodeAuth";
import { checkIfBindCustomer } from "@/api/auth";
import { allLiveList } from "@/api/active";
import { checkMixin } from "@/mixins/checkMixin";
import { getConfigParams } from "@/utils/wxCodeAuth";
import store from "@/store";
export default {
  name: "sendCardLink",
  mixins: [checkMixin],
  data() {
    return {
      keyword: "",
      mode: "",
      loading: false,
      liveList: [],
      isBindCrm: false,
    };
  },
  async created() {
    this.loading = true;
    if (this.$route.query.corpId)
      store.commit("SET_CORPID", this.$route.query.corpId);
    if (this.$route.query.agentId)
      store.commit("SET_AGENTID", this.$route.query.agentId);
    if  (this.$route.query.tenantId)
      store.commit("SET_TENANTID", this.$route.query.tenantId);
    this.getUserInfo();
    // 企微环境下检测和交互
    if (envjudge() === "com-wx-mobile" || envjudge() === "com-wx-pc") {
      console.log("检测未登录或授权111");
      // 检测未登录或授权
      this.checkLogin();
      console.log("有进来后面调用接口吗1");
      // 检查是否已绑定crm账号
      await this.checkIsBind();
      console.log("有进来后面调用接口吗");

      //获取列表
      this.allLiveList();
      //获取发送消息配置
      await this.init();
    } else {
      console.log("未登录或授权222");
    }
  },
  computed: {
    getMode() {
      return (mode) => {
        return mode == 2 ? "直播" : mode == 3 ? "回放" : "-";
      };
    },
    getLiveMode() {
      return (liveMode) => {
        return liveMode == 1
          ? "(直播)"
          : liveMode == 2
          ? "(AI直播)"
          : liveMode == 3
          ? "(回放)"
          : "-";
      };
    },
  },
  methods: {
    getUserInfo() {
      let userInfo = localStorage.getItem("userInfo");
      if (!userInfo || "" + userInfo === "undefined") {
        this.userInfo = store.getters.userInfo;
      } else {
        this.userInfo = JSON.parse(userInfo);
      }
      console.log("获取userInfo", this.userInfo);
    },
    checkLogin() {
      let userInfo = localStorage.getItem("userInfo");
      if (!userInfo || "" + userInfo === "undefined") {
        userInfo = JSON.parse(userInfo);
        console.log("未登录，path:", this.$route.path);
        this.$router.replace(
          `/login/${this.$route.query.corpId || store.getters.corpId}/${
            this.$route.query.agentId || store.getters.agentId
          }?redirect=${decodeURIComponent(this.$route.path)}`
        );
      } else {
        this.checkIsBind();
      }
    },
    async checkIsBind() {
      if (!this.externalUserId) {
        this.externalUserId = await getCurExternalContact();
      }
      try {
        const res = await checkIfBindCustomer({
          externalUserId: this.externalUserId,
          corpId: store.getters.corpId,
          tenantId: store.getters.tenantId,
        });
        if (res.result === 1) {
          this.isBindCrm = true;
        } else {
          this.isBindCrm = false;
          this.isNull = true;
          this.loading = false;
        }
      } catch (error) {
        console.error("Error while checking bind status:", error);
      }
    },
    async init() {
      let corpId = !this.$route.query.corpId
        ? state.corpId
        : this.$route.query.corpId;
      let agentId = !this.$route.query.agentId
        ? state.agentId
        : this.$route.query.agentId;
      let config = await getConfigParams(corpId, agentId, 2);
      //注册
      ww.register({
        corpId: corpId, // 必填，当前用户企业所属企业ID
        agentId: agentId, // 必填，当前应用的AgentID
        jsApiList: ["getContext", "sendChatMessage"], // 必填，需要使用的JSAPI列表
        getConfigSignature: function () {
          // 必填，根据url生成企业签名的回调函数
          let timestamp = config.timestamp;
          let nonceStr = config.nonceStr;
          let signature = config.signature;
          return { timestamp, nonceStr, signature };
        },

        getAgentConfigSignature: function () {
          // 必填，根据url生成企业签名的回调函数
          let timestamp = config.timestamp;
          let nonceStr = config.nonceStr;
          let signature = config.signature;
          return { timestamp, nonceStr, signature };
        },
        onAgentConfigSuccess: function (e) {
          console.log("AgentConfigSuccess", e);
        },
        onAgentConfigFail: function (e) {
          console.log("AgentConfigFail", e);
        },
      });
    },
    async allLiveList() {
      this.loading = true;
      const obj = {
        corpId: store.getters.corpId,
        wechatUserId: this.userInfo.userId,
        keyword: this.keyword,
        mode: this.mode,
      };
      let res = await allLiveList(obj);
      if (res.code == 200) {
        this.loading = false;
        this.liveList = res.result || [];
      }
    },
    onSend(val) {
      if (!this.isBindCrm) {
        this.$message.warning("请先绑定CRM名片");
        return;
      }
      let that = this;
      ww.checkJsApi({
        jsApiList: ["getContext", "sendChatMessage"],
        fail: function (err) {
          that.$message.error(
            "初始化失败，重新登录企微试试吧！" + JSON.stringify(err)
          );
        },
      });
      let defaultIconUrl =
        "https://mediaplatform.cos.cveteth.com/template/icon_default.png";
      let imgUrl = val.iconUrl || defaultIconUrl;
      let desc = val.startTime
        ? `【开课时间:${val.startTime}】点击进入直播间观看~`
        : "【即将开课】点击进入直播间观看~";
      const news = {
        link: val.liveUrl,
        title: val.liveTitle,
        desc: desc,
        imgUrl: imgUrl,
      };
      ww.sendChatMessage({
        msgtype: "news",
        enterChat: true,
        news,
        success(res) {
          console.log("分享成功", res);
          that.$message.success("分享成功");
        },
        fail(err) {
          console.log("分享失败", err);
          that.$message.error(
            "分享失败" + JSON.stringify(err) + JSON.stringify(news)
          );
        },
      });
    },
    onSearch() {
      this.allLiveList();
    },
    onChange() {
      this.allLiveList();
    },
  },
};
</script>
<style lang="less" scoped>
.sendCardLink {
  height: 100vh;
  background: #f5f5f5;
}

.search-bar {
  padding: 10px;
  padding-right: 20px;

  /deep/.ant-input-search {
    display: block;

    > input {
      border-color: #fff;
    }
  }

  .custom-radio-group {
    margin-top: 10px;
    display: inline-flex;
    width: 100%;

    .ant-radio-button-wrapper {
      width: 100%;
      text-align: center;
    }

    .ant-radio-button-wrapper:first-child {
      border-radius: 16px 0 0 16px;
    }

    .ant-radio-button-wrapper:last-child {
      border-radius: 0 16px 16px 0;
    }
  }
}

.cardList {
  max-height: calc(100vh - 110px);
  overflow-y: scroll;
  overflow-x: clip;
  padding: 0 15px 0 10px;

  ::v-deep {
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-thumb {
      height: 74px;
      background: #bec1c6;
      border-radius: 6px;
    }
  }

  .cardItem {
    display: flex;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    margin-bottom: 10px;

    .left {
      width: 85%;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;

      .title {
        display: flex;
        padding: 10px 0 10px 10px;

        .t-left {
          width: 80%;
          padding-right: 15px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #10141a;
          text-align: left;
          font-style: normal;
          text-transform: none;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: normal;
        }

        .t-right {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 12px;
          color: #1890ff;
          text-align: right;
          font-style: normal;
          text-transform: none;
          padding: 0 8px;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #1890ff;
        }
      }

      .no {
        display: flex;
        padding: 0 10px 10px 10px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #818d99;
        font-style: normal;
        text-transform: none;

        .teacher {
          display: block;
          width: 50%;
        }
      }
    }

    .right {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 15%;
      background: #1890ff;
      border-radius: 0px 4px 4px 0px;
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      font-style: normal;
      text-transform: none;
      transition: background-color 0.3s ease;
      cursor: pointer;
    }

    .right:active {
      opacity: 0.8;
      transform: scale(0.98);
    }
  }
}
</style>
